import Vue from 'vue';
import VueRouter from 'vue-router';
import { getAdapter } from '@zyf2e/adapt';
import routes from './module';
// import scrollPosition from './scrollPosition';

const originalPush = VueRouter.prototype.push;
VueRouter.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};

Vue.use(VueRouter);

const router = new VueRouter({
  routes,
});

let isReplace = true;

router.beforeEach((to, from, next) => {
  const { bizChannel = 'C_TERMINAL', stamp } = to.query;
  if (bizChannel) Vue.prototype.bizChannel = bizChannel;
  const { title = '' } = to.meta;
  getAdapter().setTitle(title);
  const fromQuery = {};
  Object.keys(from.query).forEach(el => {
    const arr = ['channel', 'bizChannel'];
    if (arr.indexOf(el) >= 0) {
      fromQuery[el] = from.query[el];
    }
  });
  if (stamp) {
    isReplace = false;
    next();
    return;
  }
  next({
    name: to.name,
    // 首次加载页面如果参数没有stamp 导航栈会增加一条记录导致 APP和小程序 返回需要点击两次才能关闭webview
    replace: isReplace,
    params: to.params,
    query: {
      stamp: Date.parse(new Date()),
      ...fromQuery,
      ...to.query,
    },
  });
});

// router.afterEach(scrollPosition);
router.afterEach(({ meta }) => {
  // eslint-disable-next-line no-unused-expressions,no-console
  window.webVitals?.zyCustomContentfulPaint();
  if (meta.telescope) {
    Telescope.trackPage({ trackId: meta.telescope });
  }
});

export default router;
